import type {
  BrowserCacheLocation,
  IPublicClientApplication,
} from '@azure/msal-browser'

import { SIGN_OUT_PARAM } from '../../components/SignInPage'

const storageOptionsThatSupportRedirect: string[] = [
  'sessionStorage',
  'localStorage',
] satisfies BrowserCacheLocation[]

const postLogoutRedirectUri = `/?${SIGN_OUT_PARAM}`

export const getAuthenticationActions = (
  instance: IPublicClientApplication,
) => {
  const {
    loginPopup,
    loginRedirect,
    logoutPopup,
    logoutRedirect,
    getConfiguration,
    acquireTokenRedirect,
    acquireTokenPopup,
  } = instance

  const isSupportingRedirect = storageOptionsThatSupportRedirect.includes(
    getConfiguration.call(instance).cache.cacheLocation, // using `call(instance)` to ensure it's bound to the instance (has the correct 'this' context)
  )

  return {
    login: isSupportingRedirect
      ? loginRedirect.bind(instance)
      : loginPopup.bind(instance),
    logout: isSupportingRedirect
      ? logoutRedirect.bind(instance, { postLogoutRedirectUri })
      : logoutPopup.bind(instance, { postLogoutRedirectUri }),
    acquireTokenInteractively: isSupportingRedirect
      ? acquireTokenRedirect.bind(instance)
      : acquireTokenPopup.bind(instance),
  }
}
